import { Box, Flex, Text } from '@chakra-ui/react'
import {
  colors,
  FieldMap,
  isFieldMap,
  isInfoStage,
  objectToArray,
  ValidationErrors,
  WithId,
} from '@hb/shared'
import { useMemo } from 'react'
import { useGynCareView } from './context'

const StageProgressItem = ({
  index,
  subStage,
  isLast,
  errors,
  submitted,
}: {
  index: number
  subStage: FieldMap
  isLast: boolean
  errors: ValidationErrors
  submitted: boolean
}) => (
  <Box
    bg="#efefef"
    borderRightRadius={isLast ? 6 : 0}
    borderLeftRadius={index === 0 ? 6 : 0}
    minW="120px"
    flex={1}
    py={1}
    pl={isLast ? 0.5 : 1}
    pr={index === 0 ? 0.5 : 1}>
    <Flex
      bg={!errors && submitted ? `${colors.green.hex}cc` : '#dbdbdb'}
      border="1px solid"
      borderColor={!errors && submitted ? `${colors.green.hex}ff` : '#cacaca'}
      borderRightRadius={isLast ? 6 : 0}
      justifyContent="center"
      alignItems="center"
      py={1}
      px={3}
      height="100%"
      borderLeftRadius={index === 0 ? 6 : 0}>
      <Text
        fontFamily="Hero-New"
        fontWeight={500}
        fontSize="sm"
        textAlign="center"
        textShadow={!errors && submitted ? '1px 1px 3px #00000055' : undefined}
        color={!errors && submitted ? 'gray.100' : 'gray.500'}>
        {subStage.name}
      </Text>
    </Flex>
  </Box>
)

export const StageProgress = () => {
  const { formStatus, stages, stageIndex, formData } = useGynCareView()
  const stage = useMemo(() => stages[stageIndex], [stages, stageIndex])

  const subStages = useMemo(
    () =>
      objectToArray(stage.children).filter(s => !isInfoStage(s) && isFieldMap(s)) as Array<
        WithId<FieldMap>
      >,
    [stage],
  )
  if (subStages.length < 2) return null // Only show if there are at least 2 sub-stages

  return (
    <Flex
      filter="drop-shadow(1px 1px 4px #00000033)"
      borderRadius={6}
      w="100%"
      pb={1}
      justifyContent="center">
      {subStages.map((subStage, index) => (
        <StageProgressItem
          key={subStage.id}
          errors={formStatus.stages[stage.id]?.errors?.[subStage.id]}
          submitted={!!formData?.[stage.id]?.updatedOn}
          index={index}
          subStage={subStage}
          isLast={index === subStages.length - 1}
        />
      ))}
    </Flex>
  )
}
